<template>
  <v-container>
    <material-card
      :title="Data.exam_name"
      :text="'Question available: ' + Data.questions_count"
      color="green"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Question"
                class="green-input"
                v-model="question.question"
                prepend-icon="text_fields"
                :rules="questionRule"
              />
            </v-flex>

            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 1"
                class="green-input"
                v-model="question.option1"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 2"
                class="green-input"
                v-model="question.option2"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 3"
                class="green-input"
                v-model="question.option3"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 4"
                class="green-input"
                v-model="question.option4"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 5"
                class="green-input"
                v-model="question.option5"
                prepend-icon="text_fields"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 6"
                class="green-input"
                v-model="question.option6"
                prepend-icon="text_fields"
              />
            </v-flex>
            <v-flex md12>
              <b>Correct Answer</b>
              <!-- <v-radio-group v-model="question.correct_answer" row :rules="correctAnsRule">
                <v-radio label="Option 1" :value="1"></v-radio>
                <v-radio label="Option 2" :value="2"></v-radio>
                <v-radio label="Option 3" :value="3"></v-radio>
                <v-radio label="Option 4" :value="4"></v-radio>
              </v-radio-group> -->
              <!-- 
              <template v-if="question.correct_answer > 1"> </template>
              <template v-else> </template> -->

              <v-layout wrap>
                <v-flex md2>
                  <v-checkbox
                    true-value="'1'"
                    :value="1"
                    v-model="question.correct_answer"
                    label="Option 1"
                  ></v-checkbox>
                </v-flex>

                <template v-if="question.correct_answer > 1">
                  
                  <v-flex md2>
                    <v-checkbox 
                      true-value="'2'"
                      :value="2"
                      v-model="question.correct_answer"
                      label="Option 2"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'3'"
                      :value="3"
                      v-model="question.correct_answer"
                      label="Option 3"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'4'"
                      :value="4"
                      v-model="question.correct_answer"
                      label="Option 4"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'5'"
                      :value="5"
                      v-model="question.correct_answer"
                      label="Option 5"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'6'"
                      :value="6"
                      v-model="question.correct_answer"
                      label="Option 6"
                    ></v-checkbox>
                  </v-flex>

                  
                </template>
                <template v-else>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'2'"
                      :value="2"
                      v-model="question.correct_answer2"
                      label="Option 2"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'3'"
                      :value="3"
                      v-model="question.correct_answer3"
                      label="Option 3"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'4'"
                      :value="4"
                      v-model="question.correct_answer4"
                      label="Option 4"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'5'"
                      :value="5"
                      v-model="question.correct_answer5"
                      label="Option 5"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox
                      true-value="'6'"
                      :value="6"
                      v-model="question.correct_answer6"
                      label="Option 6"
                    ></v-checkbox>
                  </v-flex>
                </template>
              </v-layout>
            </v-flex>

            <v-flex md12>
              <b>Explanation</b>
              <v-textarea
                name="input-7-1"
                label="Explanation Text"
                class="green-input"
                hint="Explanation Text"
                prepend-icon="text_fields"
                v-model="question.explanation_text"
              ></v-textarea>
            </v-flex>
            <v-flex md12>
              <v-text-field
                v-model="explanation"
                label="Explanation"
                @click="pickThumbnail"
                prepend-icon="attach_file"
                class="green-input"
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="explanation"
                accept="image/*"
                @change="onThumbnailPicked"
              />
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                @click="onClickButton"
                >{{ Item.submitText }}</v-btn
              >

              <v-btn
                class="mx-2 font-weight-light"
                color="info"
                @click="closeQuestionModal"
                >Close</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
export default {
  props: {
    Data: Object,
    Question: Object,
    isEdit: Boolean,
  },
  data() {
    return {
      Item: {
        title: "Add new question",
        subTitle: "Please fill all fields",
        submitText: "Submit",
      },
      explanation: "",
      valid: true,
      question: {},
      questionRule: [(v) => !!v || "Question is required."],
      optionRule: [(v) => !!v || "Option is required."],
      correctAnsRule: [(v) => !!v || "Option is required."],
    };
  },
  watch: {
    Question: function () {
      this.question = this.Question;
    },
  },
  created() {
    this.question = {};
  },
  methods: {
    onClickButton(event) {
      if (this.$refs.form.validate()) {
        this.$emit("emitted", this.question);
      }
    },
    closeQuestionModal() {
      this.$emit("closedQuestion");
    },
    pickThumbnail() {
      this.$refs.explanation.click();
    },
    onThumbnailPicked(event) {
      this.fileName = this.$refs.explanation.files[0].name;
      this.explanation = this.fileName;
      this.question.ext = this.fileName.substr(
        this.fileName.lastIndexOf(".") + 1
      );
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.question.file = reader.result.split(",")[1];
      };
    },
  },
};
</script>
